/* global DocViewerEvents */
(function() {
    // Directives used in our document page
    angular.module('GorillaBoy.DocumentViewer')
    .directive('onlineEditingLauncher', ['$timeout', 'FeatureManagerService', 'Features', '$log', function($timeout, FeatureManagerService, Features, $log) {
        return {
            restrict : 'A',
            scope: {
                onlineEditingLauncher : '=',
                documentMetadata : '='
            },
            link : function onlineEditingLauncherLinkFn($scope, $element, $attrs) {
                var ONLINE_EDITOR_IFRAME_ELEMENT_ID = "online_editor_iframe";
                var hancomCloseApiResponse = null;
                var EXIT_API_FAIL = "fail";
                var EXIT_API_SUCCESS = "success";
                var EXIT_API_SUCCESS_RESPONSE = "succeed";
                if ($scope.onlineEditingLauncher === undefined || $scope.onlineEditingLauncher === "") {
                     $element.append("<iframe src=\" about:blank \" style=\" height: 100%;width: 100%;border: 0px;\" " +
                    "allowfullscreen=\"true\" allow-presentation=\"true\" allow-popups=\"true\" id=\""+ ONLINE_EDITOR_IFRAME_ELEMENT_ID  +"\" ></iframe>");
                } else {
                      //We should insert iframe directly with the right SRC value. We cannot use ng-src and have this iframe in a template becuase change in ngSrc value will add
                //extraneous history entries and interfere with Back button functionality.
                    $element.append("<iframe src=\"" + $scope.onlineEditingLauncher + "\" style=\"height: 100%;width: 100%;border: 0px;\" " +
                    "allowfullscreen=\"true\" allow-presentation=\"true\" allow-popups=\"true\" onload=\"iframeLoaded()\" id=\""+ ONLINE_EDITOR_IFRAME_ELEMENT_ID  +"\"></iframe>");
                }
              
                window.onunload = function(event) {
                    console.log("===> workdocs unload!!!");
                    var webOffice = document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID);
                    if (webOffice) {
                        webOffice.src = "about:blank";
                        webOffice.parentNode.removeChild(webOffice);
                    }
                };

                $scope.$on("$routeChangeStart", function(event, next, current) {
                    if($scope.redirectPath){
                        $scope.redirectPath="";
                        return;
                    }
                    event.preventDefault();
                    // Post Message to Iframe online editor to notify the user exited the session.
                    // This message ensures that hancom saves the file.
                    var iFrame = document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID);
                    iFrame.contentWindow.postMessage(messageForExitFromOnlineEditor(),"*");

                    var routeObj = next;
                    var path = routeObj.$$route.originalPath;
                    var keys = routeObj.$$route.keys;
                    var value;       
                    for (var i = 0; i < keys.length; i++) {
                        if(angular.isDefined(keys[i]) && angular.isDefined(keys[i].name)){
                            value = routeObj.pathParams[keys[i].name];
                            var regEx = new RegExp(":" + keys[i].name, "gi");
                            path = path.replace(regEx, value.toString());            
                        }
                    }

                    if(hancomCloseApiResponse && hancomCloseApiResponse === EXIT_API_FAIL){
                        $log.info("Route change prevented because Thinkfree Office sent fail in app.close api");
                        hancomCloseApiResponse = null;
                        $scope.rerouteAfterSuccess = path;
                        event.preventDefault();
                        return;
                    } else if(!hancomCloseApiResponse) {
                        $log.info("Route change prevented because we did not receive a response from Thinkfree Office on app.close api yet.");
                        $scope.rerouteAfterSuccess = path;
                        event.preventDefault();
                        return;
                    } else {
                        $log.info("Successfully rerouting");
                        hancomCloseApiResponse=null;
                    }

                    $scope.redirectPath = path;
                    var webOffice = document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID);
                    isHancomDelayEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.HANCOM_ADD_DELAY);
                    if (webOffice) {
                        if(isHancomDelayEnabled){
                            setTimeout(function () {
                                webOffice.src = 'about:blank';
                            }, 100);
                        } else {
                            webOffice.src = 'about:blank';
                        } 
                    }
                });

                window.iframeLoaded=function(){
                    var saveAndExitDivision = $('.save-and-exit-division');
                    if(saveAndExitDivision.length !== 0) {
                        saveAndExitDivision[0].style.display='inline';
                    }

                    var webOffice = document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID);
                    if (webOffice && webOffice.src === "about:blank") {
                        webOffice.parentNode.removeChild(webOffice);
                        var replacetext='#'+$scope.redirectPath;
                        var href=window.location.href.replace(window.location.hash,replacetext);
                        window.location.replace(href);
                    }
                };

                function messageForExitFromOnlineEditor() {
                    var contentType = $scope.documentMetadata.VersionMetadata.ContentType;
                    var editorApp = "webwordApp";
                    switch (contentType) {
                        case 'application/vnd.ms-excel':
                        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                            editorApp = "webcellApp";
                            break;

                        case 'application/vnd.ms-powerpoint':
                        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                            editorApp = "webshowApp";
                            break;
                    }

                    var message=JSON.stringify({
                      "ThinkfreeWeboffice": {
                        "app": editorApp,
                        "version": "v1.0",
                        "type": "cmd",
                        "method": "App.close",
                        "params": [],
                        "id": $scope.documentMetadata.Id + $scope.documentMetadata.VersionMetadata.VersionId
                      }
                    });

                    return message;
                }

                window.addEventListener('message',iframeMessageListener, false);

                function iframeMessageListener(event) {
                    $log.info("Inside iframeMessageListener");
                    var messageObject = JSON.parse(event.data);

                    if(messageObject.ThinkfreeWeboffice && messageObject.ThinkfreeWeboffice.type && messageObject.ThinkfreeWeboffice.type === "result"){
                        $log.info("Value from API="+messageObject.ThinkfreeWeboffice.data);
                        if(messageObject.ThinkfreeWeboffice.data === EXIT_API_SUCCESS_RESPONSE){
                            $log.info("Received Success from Thinkfree Office");
                            hancomCloseApiResponse = EXIT_API_SUCCESS;
                            $log.info("Goto = "+$scope.rerouteAfterSuccess);

                            var replacetext='#'+$scope.rerouteAfterSuccess;
                            var href=window.location.href.replace(window.location.hash,replacetext);
                            window.location.replace(href);
                        } else {
                            $log.info("Received Fail from Thinkfree Office");
                            hancomCloseApiResponse = EXIT_API_FAIL;
                        }
                    } else {
                        $log.info("Not a valid type of Message");
                    }
                }

                $scope.$on("$destroy",function(){
                    window.removeEventListener('message',iframeMessageListener);
                });
            }
        };
    }])
    .directive('immersiveReadingTitleBar', ['$timeout', function($timeout) {
        return {
            restrict : 'A',
            link : function immersiveReadingTitleBarLinkFn($scope, $element, $attrs) {
                var $elem = $element.parent(),
                    immersiveReadingStarted = true,
                    elem = $elem.get(0);
                var elemClientHeight = elem.clientHeight;
                var mainContentTop = 43; //has to be in sync with _document-viewer.scss
                var showPanels = function() {
                    var mainContent = document.getElementById("mainContent");
                    mainContent.style.top = mainContentTop + 'px';
                    elem.style.height = elemClientHeight + 'px';
                    elem.style.overflow = "visible";
                };
                var hidePanels = function() {
                    immersiveReadingStarted = true;
                    var mainContent = document.getElementById("mainContent");
                    elem.style.overflow = "hidden";
                    //Give a 2px sliver so that user can barely see these hidden panels
                    elem.style.height = 5 + 'px';
                    mainContent.style.top = 5 + 'px';
                };
                $scope.$watch('documentState.activeVersion.VersionId', function(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    if (immersiveReadingStarted) {
                        showPanels();
                    }
                });

                $scope.documentState.documentViewerBridge.on(DocViewerEvents.IMMERSIVE_READING_OFF, showPanels);
                $scope.documentState.documentViewerBridge.on(DocViewerEvents.IMMERSIVE_READING_ON, hidePanels);
                $scope.$watch('documentState.documentMenuOpen || documentState.versionDropdownOpen', function(newVal, oldVal) {
                    if (newVal) {
                        $scope.documentState.documentViewerBridge.pauseImmersiveReading();
                    } else {
                        $scope.documentState.documentViewerBridge.resumeImmersiveReading();
                    }
                });

                $scope.$on("$destroy", function() {
                    $scope.documentState.documentViewerBridge.off(DocViewerEvents.IMMERSIVE_READING_OFF, showPanels);
                    $scope.documentState.documentViewerBridge.off(DocViewerEvents.IMMERSIVE_READING_ON, hidePanels);
                });
            }
        };
    }])
    //Sai: I don't think this "deadlineValid" directive is used in our application. Double check and remove it
    .directive('deadlineValid', ['DateFormatter', function (DateFormatter) {
        return {
            link: function (scope, elm, attrs, ctrl) {
                elm.on('change changeDate click blur', function () {
                    scope.setDatetimeInputs();
                    scope.requestFeedback.hasDeadline = true;
                });

                scope.setDatetimeInputs = function () {
                    var currentInput = $($('#datepicker > input')[0]).val();
                    scope.requestFeedback.deadlineDate = (currentInput === '') ? scope.generateEarliestDeadline() : currentInput;
                    scope.safeApply(function() {
                        scope.requestFeedback.deadlineDatetime = (scope.requestFeedback.deadlineDate + " " + scope.requestFeedback.deadlineHour + ":" + scope.requestFeedback.deadlineMinute + ":" + scope.requestFeedback.deadlineAMPM);
                    });
                    scope.checkTimeValidity(scope.requestFeedback.deadlineDatetime);
                };
            },
            controller: ['$scope', 'MessageProvider', 'DateFormatter', function ($scope, MessageProvider, DateFormatter) {
                $scope.generateEarliestDeadline = function () {
                    // Lock if this has already been generated
                    if ($scope.requestFeedback.earliestDeadline !== null) {
                        return $scope.requestFeedback.deadlineDate === $scope.requestFeedback.earliestDeadline;
                    }
                    // Returns integer that will be placed into
                    var now = DateFormatter.createTimezoneDate(new Date()),
                        now_short_date = DateFormatter.getShortDate(now),
                        now_epoch = now.getTime();

                    var potential_time = DateFormatter.parseToTimezoneDate(now_short_date + $scope.requestFeedback.DEFAULT_DEADLINE);

                    if (potential_time > now_epoch) {
                        $scope.requestFeedback.deadlineDate = $scope.requestFeedback.earliestDeadline = now_short_date;
                    } else {
                        // Calculate tomorrow's time @ 5:00 pm
                        potential_time = DateFormatter.createTimezoneDate(potential_time + DateFormatter.MILLISECONDS_PER_DAY);
                        $scope.requestFeedback.deadlineDate = $scope.requestFeedback.earliestDeadline = DateFormatter.getShortDate(potential_time);
                    }
                    return $scope.requestFeedback.deadlineDate;
                };

                $scope.$watch('requestFeedback.deadlineMinute', function () {
                    $scope.setDatetimeInputs();
                });

                $scope.$watch('requestFeedback.deadlineAMPM', function () {
                    $scope.setDatetimeInputs();
                });

                $scope.$watch('requestFeedback.deadlineHour', function () {
                    $scope.setDatetimeInputs();
                });

                $scope.$watch('requestFeedback.deadlineDate', function () {
                    $scope.setDatetimeInputs();
                });

                $scope.checkTimeValidity = function (deadlineDatetime) {
                    var feedback_date = $scope.requestFeedback.deadlineDate.split('/'),
                        feedback_time = DateFormatter.parseToTimezoneDate(deadlineDatetime),
                        now_time = DateFormatter.createTimezoneDate(new Date());

                    // Do comparisons
                    var isValidDate = feedback_time &&
                        (feedback_date[0] == (feedback_time.getMonth() + 1) &&
                        feedback_date[1] == feedback_time.getDate() &&
                        feedback_date[2] == feedback_time.getYear() + 1900);
                    var isLaterThanNow = feedback_time > now_time;

                    if (!isValidDate) {
                        $scope.requestFeedback.deadlineTimeMessage = MessageProvider.feedbackDeadlineInvalid;
                    }
                    else if (!isLaterThanNow) {
                        $scope.requestFeedback.deadlineTimeMessage = MessageProvider.feedbackDeadlineCannotBeInPast;
                    }
                    else {
                        $scope.requestFeedback.deadlineTimeMessage = "";
                    }

                };
            }]
        };
    }]);
}());
